import FlagIndonesia from "@/assets/logos/Flag_of_Indonesia.png";
import FlagUS from "@/assets/logos/Flag_of_the_United_States.png";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export default function ToggleLanguage() {
  const { i18n } = useTranslation();

  const handleChangeLanguage = (lang: "id" | "en") => {
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
  };

  return (
    <div className="flex items-center gap-2">
      <div className="flex p-1 bg-slate-100 dark:bg-slate-900 rounded-full border border-slate-200 dark:border-slate-800 shadow-inner transition-colors duration-300">
        {/* Tombol Indonesia */}
        <button
          onClick={() => handleChangeLanguage("id")}
          className={cn(
            "flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-300 ease-in-out",
            i18n.language === "id"
              ? "bg-white dark:bg-slate-800 text-slate-900 dark:text-white shadow-sm ring-1 ring-slate-200 dark:ring-slate-700"
              : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 hover:bg-slate-200/50 dark:hover:bg-slate-800/50"
          )}
        >
          <img
            src={FlagIndonesia}
            alt="ID"
            className="w-4 h-4 object-cover rounded-full shadow-sm"
          />
          <span>ID</span>
        </button>

        {/* Tombol English */}
        <button
          onClick={() => handleChangeLanguage("en")}
          className={cn(
            "flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-300 ease-in-out",
            i18n.language === "en"
              ? "bg-white dark:bg-slate-800 text-slate-900 dark:text-white shadow-sm ring-1 ring-slate-200 dark:ring-slate-700"
              : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 hover:bg-slate-200/50 dark:hover:bg-slate-800/50"
          )}
        >
          <img
            src={FlagUS}
            alt="EN"
            className="w-4 h-4 object-cover rounded-full shadow-sm"
          />
          <span>EN</span>
        </button>
      </div>
    </div>
  );
}
